import { render } from "./AddGuessModal.vue?vue&type=template&id=8f303772"
import script from "./AddGuessModal.vue?vue&type=script&lang=js"
export * from "./AddGuessModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__